import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import { setAutoTranslateLang } from "../lib/autoTranslate";

/** Activates the global DOM auto-translation engine for logged-in users. */
export default function AutoTranslate() {
    const { user } = useAuth();
    const { i18n } = useTranslation();
    const lang = (i18n.resolvedLanguage || i18n.language || "en").slice(0, 2);

    useEffect(() => {
        setAutoTranslateLang(user && lang !== "en" ? lang : "en");
    }, [user, lang]);

    useEffect(() => () => setAutoTranslateLang("en"), []);
    return null;
}
